import { useState } from "react";
import UploadedFiles from "./TranscriptioFIles";
import UploadFile from "./UploadFile";

const HomePage = () => {
  const [uploadedFileData, setUploadedFileData] = useState(null);
  return (
    <>
      <UploadFile setUploadedFileData={setUploadedFileData} />
      <UploadedFiles uploadedFileData={uploadedFileData} setUploadedFileData={setUploadedFileData} />
    </>
  );
};

export default HomePage;
